import { render } from "./HomeMenu.vue?vue&type=template&id=1132ea14&scoped=true"
import script from "./HomeMenu.vue?vue&type=script&lang=js"
export * from "./HomeMenu.vue?vue&type=script&lang=js"

import "./HomeMenu.vue?vue&type=style&index=0&id=1132ea14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1132ea14"]])

export default __exports__